import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useModelsTradeNamesAndProducts(
  families = [],
  supplierID = "",
  brands = [],
  category = "",
) {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post(
      "ListarModelosNombresComercialesProductos.php",
      {
        token: userData.token,
        familias: families,
        idProveedor: supplierID,
        marcas: brands,
        categoria: category,
      },
    );
    setList(response);
  }

  useEffect(() => {
    getData();
  }, [JSON.stringify(families), supplierID, JSON.stringify(brands), category]);

  return [list, getData];
}
